export const NextStepClickAction = (event) => {
  return (dispatch, getState) => {
    alert('You Clicked Action')
  }
}

export const AvantClickActiveProduct = (event, id) => {
  return (dispatch, getState) => {
    dispatch({type: 'TOGGLE_OWNER'})
  }
}

export const getApplicationItemLayout = (customer_application) => {
  return (dispatch, getState) => {
    const { layouts } = getState()
    return layouts.IncompleteApplicationItemLayout
  }
}

export const navigateToOpenApplication = (customer_application_id) => {
  return (dispatch, getState) => {
    const { stage } = getState().data.customer_applications.find(app => app.id === customer_application_id)
    if(stage === 'verification') return `/customer/home?customer_application_id=${customer_application_id}`
    return `/apply/${customer_application_id}`
  }
}

export const loadLayouts = (layouts) => {
  return {
    type: 'RECEIVE_LAYOUTS',
    layouts
  }
}

export const getApplicationItemAdditionalMessageLayout = (status) => {
  return (dispatch, getState) => {
    const { layouts } = getState()
    if(status === 'incomplete') return null
    return layouts.ApplicationItemAdditionalMessageLayout
  }
}

export const getProductLayout = (product) => {
  return (dispatch, getState) => {
    const { layouts } = getState()
    const { product_type, status, issuer, debt_buyer, debt_buyer_phone, bad_bank_account, is_opted_into_ach, is_opted_into_rcc, payment_method, cx_dash_payoff_info } = product
    const achOptedIn = payment_method === 'ach' && is_opted_into_ach
    const rccOptedIn = payment_method === 'rcc' && is_opted_into_rcc
    const pendingPayoff = cx_dash_payoff_info && cx_dash_payoff_info.payoff_info
    const badBankOptedIn = bad_bank_account && (achOptedIn || rccOptedIn)

    if (product_type === 'credit_card') return layouts.AvantCreditCardAccountLayout

    if(status === 'late') return layouts.LateProductLayout
    if(status === 'current' && (badBankOptedIn || pendingPayoff)) return layouts.CurrentProductLayout
    if(status === 'paid_off') return layouts.PaidOffProductLayout
    if(status === 'charged_off' && debt_buyer === null && debt_buyer_phone === null) return layouts.ChargedOffProductLayout
    if(status === 'charged_off') return layouts.SoldProductLayout
    if(status === 'applied') return layouts.AppliedProductLayout
    if(status === 'transferred' && issuer === 'regions') return layouts.TransferredProductLayout

    return layouts.AvantProductLayout
  }
}

export const MakePaymentAction = (loan_id) => {
  return (dispatch, getState) => {
    if (window.avantEnv && window.avantEnv.MAKE_PAYMENT_FOR_CUSTOMER_CLIENTS_ENABLED)
      return `/dashboard#/loans/${loan_id}/workflows/loans/make_payment`
    else
      return `/dashboard#/loans/${loan_id}/payment/add`
  }
}

export const UpdateBankAction = (loan_id) => {
  return (dispatch, getState) => {
    return `/dashboard#/loans/${loan_id}/workflows/customer/update_bank_account`
  }
}

export const StartFSRWorkflowAction = (loan_id) => {
  return (dispatch, getState) => {
    return `/dashboard#/loans/${loan_id}/workflows/customer/financial_situation_review`
  }
}

export const getProductTypeTemplate = (product_type) => {
  return (dispatch, getState) => {
    return `product.types.${product_type}`
  }
}

export const CloseSpecificNotice = (notice_type) => {
  return(dispatch, getState) => {
    dispatch({type: `REMOVE_NOTICE`, notice_type })
  }
}

export const CloseHeaderNotice = (index) => {
  return(dispatch, getState) => {
    dispatch({type: 'REMOVE_WORKFLOW_NOTICE', index})
  }
}

export const GetWorkflowUrl = (name, type, loan_id) => {
  return(dispatch, getState) => {
    return `/dashboard#/loans/${loan_id}/workflows/${type}/${name}`
  }
}

export * from './http'
